import * as React from 'react';

import {Checkbox} from 'shells/checkbox/checkbox';

import type {AvailabilityDay} from 'nutshell-graphql-types';
import type {SetAvailability_availabilitySet_availability_times as AvailabilityTime} from 'nutshell-graphql-types';

import {DayAvailabilityTimes} from './day-availability-times';
import {getDefaultAvailabilityTimesForDay} from './helpers';

import styles from './availability-config.module.css';

type Props = {
    dayOfWeek: AvailabilityDay;
    availabilityTimes: AvailabilityTime[];
    onChange: (newTimes: AvailabilityTime[]) => void;
};

export function DayRow(props: Props) {
    const hasAvailability = Boolean(props.availabilityTimes.length);
    const label = props.dayOfWeek.charAt(0) + props.dayOfWeek.slice(1).toLowerCase();
    const toggleAvailability = () => {
        if (hasAvailability) {
            props.onChange([]);
        } else {
            props.onChange(getDefaultAvailabilityTimesForDay(props.dayOfWeek));
        }
    };

    return (
        <div className={styles.row}>
            <div className={styles['left-content']}>
                <Checkbox label={label} checked={hasAvailability} onChange={toggleAvailability} />
            </div>
            {hasAvailability ? (
                <DayAvailabilityTimes
                    availabilityTimes={props.availabilityTimes}
                    onChange={props.onChange}
                />
            ) : (
                <div className={styles.unavailable}>Unavailable</div>
            )}
        </div>
    );
}
